const imgData_2020 = {
  sandworts: {
    title: 'Sandworts',
    imgs: {
      full: {
        src: require('./sandworts_2020_web.jpg'),
        width: 714,
        height: 1000,
      },
      thumb: {
        src: require('./sandworts_2020_thumb.jpg'),
        width: 428,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 210 x 297 mm, 2020.',
    price: 94,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/933507942/',
    printUrl: '',
    merch: [
      {
        name: 'Greeting cards',
        url: 'https://www.etsy.com/ie/listing/943508801/',
        price: 3.5,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
      {
        name: 'Postcard set',
        url: 'https://www.etsy.com/ie/listing/928314268/',
        price: 5,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'This is the second of my spring collection prints: a pair of blue tits and an Irish wildflower, Sandworts. This painting was created as a t-shirt print, but postcards and greeting cards are also made with it!',
  },
  cuckooflowers: {
    title: 'Cuckooflowers',
    imgs: {
      full: {
        src: require('./cuckooflowers_2020_web.jpg'),
        width: 714,
        height: 1000,
      },
      thumb: {
        src: require('./cuckooflowers_2020_thumb.jpg'),
        width: 428,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 297 x 420 mm, 2020.',
    price: 120,
    original: 'AVAILABLE',
    prints: 'NOTYET',
    printPrice: 0,
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/933499334/',
    printUrl: '',
    merch: [
      {
        name: 'Greeting cards',
        url: 'https://www.etsy.com/ie/listing/943508801/',
        price: 3.5,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
      {
        name: 'Postcard set',
        url: 'https://www.etsy.com/ie/listing/928314268/',
        price: 5,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'This is the first of my spring collection prints: a pair of grey herons in their courting dance, and some cuckooflowers to get that spring vibe going. Herons start courting in mid-February, taking on their party looks: bright orange beaks and fresh plumage.<br /><br />There are t-shirts, greeting cards and postcards available with this print!',
  },
  we_belong: {
    title: 'We Belong',
    imgs: {
      full: {
        src: require('./we_belong_2020_web.jpg'),
        width: 800,
        height: 1000,
      },
      thumb: {
        src: require('./we_belong_2020_thumb.jpg'),
        width: 480,
        height: 600,
      },
    },
    year: '2020',
    description: 'Ink and watercolour on acrylic paper. 405 x 508 mm, 2020.',
    price: 200,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 26.95,
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/925362562/',
    merch: [
      {
        name: 'Bookmark Set',
        url: 'https://www.etsy.com/ie/listing/964814293/',
        price: 4.5,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '"I will not sell thee indeed," said Ecohaid, "but let him put his arms round thee in the middle of the house as thou art." "It shall be done," said Midir. He takes his weapons in his left hand, and the woman he took under his right arm, and bore her away through the skylight of the house. The hosts rose up in shame around the king. They beheld two swans in flight around Tara. (from the <i>Wooing of Étaín</i>)<br /><br />It\'s hard to summarize this story as it\'s a crazy one, and easily beats any soap opera! So in short, Midir takes Étaín, the most beautiful woman as his wife. But his first wife turns Étaín into a pool of water, from which she evaporates and becomes a fly, and after many adventures she lands in the drink of the wife of Étar, a warrior. She swallows the fly and becomes pregnant, giving birth to Étain again after 1012 years of her first birth. She gets wed to Eochu, high king of Ireland. Meanwhile Midir learns his long lost love is alive, and challenges Eochu in a chess game to get a kiss from Étaín if he wins. Of course he won, and when embracing Étaín they both turn into swans and escape.<br /><br />This painting was commissioned to contain a folklore element and swans, so I chose this love story from Celtic mythology to serve as my inspiration.',
  },
  muruchaill: {
    title: 'Murúchaill',
    imgs: {
      full: {
        src: require('./muruchaill_2020_web.jpg'),
        width: 705,
        height: 1000,
      },
      thumb: {
        src: require('./muruchaill_2020_thumb.jpg'),
        width: 423,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold-pressed watercolour paper. 297 x 420 mm, 2020.',
    price: 126,
    original: 'MSG',
    prints: 'NOTYET',
    printPrice: 0,
    buyUrl: 'https://www.etsy.com/ie/listing/932337371/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'Cormorants are quite a common view as they are drying themselves on rocks, turning their wings to face the sun, but I still find something exotic in their groups. They were seen as mermaids, and one Irish name I chose as the title of this painting means exactly that: mermaid.<br /><br />I saw this Cormorant drying his wings and grooming at Howth, Dublin.',
  },
  jacks: {
    title: 'Jacks',
    imgs: {
      full: {
        src: require('./jacks_2020_web.jpg'),
        width: 701,
        height: 1000,
      },
      thumb: {
        src: require('./jacks_2020_thumb.jpg'),
        width: 421,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on hot pressed watercolour paper. 400 x 570 mm, 2020.',
    price: 200,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 25.5,
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/923304031/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'This artwork is mostly inspired by the magpies that visit my garden every day, but I also incorporated something from tropical natural history illustrations. The character of the birds really reminded me of an Irish tale, "Jack, the cunning thief". The hero of the story can steal anything from anywhere, and outsmarts everyone. Just like these rascals! Thieves they might be, but smart ones. I have to admit I do like magpies, even though I had my share of conflict with them!',
  },
  curlew: {
    title: 'Curlew',
    imgs: {
      full: {
        src: require('./curlew_2020_web.jpg'),
        width: 706,
        height: 1000,
      },
      thumb: {
        src: require('./curlew_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on mixed media paper. 297 x 420 mm (11.7 x 16.5 in), 2020.',
    price: 180,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 24.95,
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/895285512/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "I took the reference photo on Bull Island, and I really like the beach vibe this painting radiates, the same feeling I had when I was on the beach photographing the birds. Even though it's definitely not summer any more this painting still reminds me of the gentle sea breeze and I can hear the murmur of the waves.",
  },
  alfalfa: {
    title: 'Alfalfa',
    imgs: {
      full: {
        src: require('./alfalfa_2020_web.jpg'),
        width: 714,
        height: 1000,
      },
      thumb: {
        src: require('./alfalfa_2020_thumb.jpg'),
        width: 428,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on mixed media paper. 297 x 420 mm (11.7 x 16.5 in), 2020.',
    price: 180,
    original: 'SOLD',
    prints: 'NOTYET',
    buyUrl: '',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'This is a commissioned t-shirt print for <a href="https://www.instagram.com/max_border_collie27/" target="_blank" rel="noopener noreferrer">Max</a>, a blue merle border collie. The t-shirts are now available at <a href="https://pannadraws.etsy.com/" target="_blank" rel="noopener noreferrer">Etsy store</a>!',
  },
  lirs_daughter: {
    title: "Lir's Daughter (Feathers of Tales X)",
    imgs: {
      full: {
        src: require('./lirs_daughter_2020_web.jpg'),
        width: 798,
        height: 1000,
      },
      thumb: {
        src: require('./lirs_daughter_2020_thumb.jpg'),
        width: 479,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 405 x 508 mm (16 x 20 in), 2020.',
    price: 180,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: 'https://www.etsy.com/ie/listing/902422157/',
    printUrl: 'https://www.etsy.com/ie/listing/911737817/',
    printPrice: 26.95,
    merch: [
      {
        name: 'Bookmark Set',
        url: 'https://www.etsy.com/ie/listing/964814293/',
        price: 4.5,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "\"...so she drove the children of Lir into the lake to bathe, and they did as Oifa told them. As soon as they were upon the lake she struck them with a Druid's wand of spells and wizardry and put them into the forms of four beautiful, perfectly white swans...\" (The Fate of The Children of Lir)<br /><br />So the series ends with this story, one of the most famous ones from Celtic mythology. Oifa, their stepmother, in her jealousy turned Lir's children into swans for 900 years just to see the decline of the Tuatha De Danann and their family. When Oifa's crime was discovered she was turned into an air-demon, a creature she loathed the most. But that didn't break the magic on the children who remained swans with the gift of speech and songs.<br /><br />This painting is the 10th and final piece in Feathers of Tales, my series on birds of Irish folklore.",
  },
  treasures: {
    title: 'Treasures',
    imgs: {
      full: {
        src: require('./treasures_2020_web.jpg'),
        width: 709,
        height: 1000,
      },
      thumb: {
        src: require('./treasures_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on mixed media paper. 297 x 420 mm ( 11.69 x 16.53 in), 2020.',
    price: 120,
    original: 'AVAILABLE',
    prints: 'SOLD',
    printPrice: 21.95,
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/896513203/',
    printUrl: 'https://www.etsy.com/ie/listing/889404732/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "While drawing this I was so so tempted to move it towards a contemporary issue and add plastic waste among the seashells and logs. That would have been the reality, this in my painting is the fairy tale guys...<br /><br />I took the reference photo on Bull Island and on some days its shore is a disgrace. Plastic everywhere, bottles, scraps, all the little colourful bits that doesn't fit in the greyish green on the shore. Sad.<br /><br />So this piece is kept as an imaginary scene, a dream, without the rubbish, just the natural elements. A bit of comfort and escape from reality.",
  },
  christmas_tits_2020: {
    title: 'Christmas Tits 2020',
    imgs: {
      full: {
        src: require('./christmas_tits_2020_web.jpg'),
        width: 1500,
        height: 1499,
      },
      thumb: {
        src: require('./christmas_tits_2020_thumb.jpg'),
        width: 750,
        height: 750,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 210 x 297 mm (8.27 x 11.69 in), 2020.',
    price: 110,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: 'https://www.etsy.com/ie/listing/878489796/',
    merch: [
      {
        name: 'Christmas Cards (set of 3 or 6)',
        url: 'https://www.etsy.com/ie/listing/891942385/',
        price: 8,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
    ],
    printUrl: 'https://www.etsy.com/ie/listing/1022714495/',
    printPrice: 15.95,
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'These little tits were painted to become prints for a set of Christmas greeting cards. The original paintings are a set of 3 paintings, while the cards can be bought in sets of 3 or 6 (together with the Robin cards). The 3 paintings picture two coal tits and a blue tit showcasing fantastic acrobatic skills!<br /><br />In the picture here you can see the set of holiday greeting cards, but if you head over to my shop (use the link below to the original) you can see the paintings in detail. The cards come with gold envelopes. The paintings are unframed, but mounted in 16 x 20" photo mounts and they fit in standard size frames.',
  },
  christmas_robins_2020: {
    title: 'Christmas Robins 2020',
    imgs: {
      full: {
        src: require('./christmas_robins_2020_web.jpg'),
        width: 1500,
        height: 1499,
      },
      thumb: {
        src: require('./christmas_robins_2020_thumb.jpg'),
        width: 750,
        height: 750,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 210 x 297 mm (8.27 x 11.69 in), 2020.',
    price: 110,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: 'https://www.etsy.com/ie/listing/892422311/',
    printUrl: 'https://www.etsy.com/ie/listing/1008727456/',
    printPrice: 15.95,
    merch: [
      {
        name: 'Christmas Cards (set of 3 or 6)',
        url: 'https://www.etsy.com/ie/listing/891942385/',
        price: 8,
        discount: 0,
        shop: 'cardsAndBookmarksShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'These handsome robins were painted to become prints for a set of Christmas greeting cards. The original paintings are a set of 3 paintings, while the cards can be bought in sets of 3 or 6 (together with the Tit cards). The 3 paintings picture the birds in different poses, all familiar to those who love these photogenic little birds.<br /><br />In the picture here you can see the set of holiday greeting cards, but if you head over to my shop (use the link below to the original) you can see the paintings in detail. The cards come with gold envelopes. The paintings are unframed, but mounted in 16 x 20" photo mounts and they fit in standard size frames.',
  },
  rascals: {
    title: 'Rascals',
    imgs: {
      full: {
        src: require('./rascals_2020_web.jpg'),
        width: 734,
        height: 1000,
      },
      thumb: {
        src: require('./rascals_2020_thumb.jpg'),
        width: 440,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 297 x 420 mm ( 11.69 x 16.53 in), 2020.',
    price: 135,
    printPrice: 21.95,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/870126360/',
    merch: [
      {
        name: "Artist's Sketchbook",
        url: 'https://www.etsy.com/ie/listing/888840913/',
        price: 23,
        discount: 0,
        shop: 'notebooksShop',
      },
      {
        name: "Women's t-shirt",
        url: 'https://www.etsy.com/ie/listing/1021281161/',
        price: 32,
        discount: 0,
        shop: 'clothingShop',
      },
      {
        name: "Men's t-shirt",
        url: 'https://www.etsy.com/ie/listing/875381994/',
        price: 31.5,
        discount: 0,
        shop: 'clothingShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'Originally created as at-shirt design, this painting of two mischievous starlings became one of my favourites. If anything, starlings are real characters in the garden. They appear in a group out of nowhere, raid all the bird feeders, then most of them leave. Some might remain, and then you can listen to their chit-chat in the bushes... A pleasant sound I couldn\'t believe was coming from these rascals! In this painting I also wanted to show their beauty, the amazing greenish shine in their plumage with the golden dots along their body.<br /><br />This painting was made as a t-shirt design. T-shirts and notebooks printed with this pattern are available in my <a href="https://pannadraws.etsy.com/" target="_blank" rel="noopener noreferrer">Etsy store</a>!',
  },
  farewell: {
    title: 'Farewell',
    imgs: {
      full: {
        src: require('./farewell_2020_web.jpg'),
        width: 709,
        height: 1000,
      },
      thumb: {
        src: require('./farewell_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 297 x 420 mm ( 11.69 x 16.53 in), 2020.',
    price: 115,
    printPrice: 21.95,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/870127742/',
    merch: [
      {
        name: 'Notebook',
        url: 'https://www.etsy.com/ie/listing/895826951/',
        price: 14.95,
        discount: 0,
        shop: 'notebooksShop',
      },
    ],
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'When it\'s summer, you hardly think about the time when nature starts to change colours, and some of the usual habitants of your environment leave for the winter. When I painted this swallow, originally intended it to be a t-shirt design, the little birds already left, leaving behind the autumn colours of leaves. I know they\'ll return once it\'s spring time again. Until then, farewell!<br /><br />This painting was made as a t-shirt design. T-shirts and notebooks printed with this pattern are available in my <a href="https://pannadraws.etsy.com/" target="_blank" rel="noopener noreferrer">Etsy store</a>!',
  },
  queen_of_the_wasteland: {
    title: 'Queen of the Wasteland (Feathers of Tales IX)',
    imgs: {
      full: {
        src: require('./queen_of_the_wasteland_2020_web.jpg'),
        width: 1000,
        height: 796,
      },
      thumb: {
        src: require('./queen_of_the_wasteland_2020_thumb.jpg'),
        width: 600,
        height: 478,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 508 x 405 mm (20 x 16 in), 2020.',
    price: 206,
    original: 'MSG',
    prints: 'SOLD',
    buyUrl: 'https://www.etsy.com/ie/listing/877615323/',
    printUrl: 'https://www.etsy.com/ie/listing/896392438/',
    printPrice: 26.95,
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '“Wherever there was war, either among gods or men, she, the great queen, was present, either in her own shape or on her favorite disguise, that of a hoodie or carrion crow. An old poem shows her inciting a warrior: Over his head is shrieking, A lean hag, quickly hopping, Over the points of the weapons and shields, She is the grey-haired Morrigii!” (from <a href="https://livinglibraryblog.com/the-raven-and-crow-of-the-celts-part-i-myth-and-legend/" target="_blank" rel="noopener noreferrer">Celtic Myth and Legend</a> by Charles Squires)<br /><br />The Morrigan is maybe the most well-known character of Irish myths. She sometimes appears as a goddess, but sometimes as a trio of goddesses named Macha, Babd and Namain. These badass women took the form a crow or raven and went to battle, leaving a wasteland behind.<br /><br />I\'m not a seaside kid, the largest body of water I was accustomed to as a child was a big lake. Sweet water has a very different environment than the sea, the smells, animals, and the routine is different (lack of tides!). So to me that vast empty flat field left behind after the tide with the smell of fish and seaweed looks like a wasteland: treasure hunter birds are foraging upon it, and there\'s the smell of rot and salt, but it\'s still full of life, shells and driftwood.<br /><br />That\'s where I\'ve seen this hooded crow digging the weeds in search of something to eat, at low tide near Bull Island. That wasteland is like a battlefield after the battle, you don\'t know what treasures you might find among the waste! And this is how this bird became the muse for part 9 of Feathers of Tales, my art series about birds in Irish myth and folklore.',
  },
  st_colmans_duck: {
    title: "St Colman's Duck (Feathers of Tales VIII)",
    imgs: {
      full: {
        src: require('./st_colmans_duck_2020_web.jpg'),
        width: 710,
        height: 1000,
      },
      thumb: {
        src: require('./st_colmans_duck_2020_thumb.jpg'),
        width: 426,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 297 x 420 mm (11.69 x 16.53 in), 2020. Framed.',
    price: 126,
    original: 'MSG',
    prints: 'SOLD',
    printPrice: 22.5,
    buyUrl: 'https://www.etsy.com/ie/listing/871888495/',
    printUrl: 'https://www.etsy.com/ie/listing/889392704/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "\"But as they were so tame, persons fetching water from the pond on a dark night—so the legend goes on to say—sometimes by an unlucky chance brought one of them away in the vessel without knowing it, and threw the contents, bird and all, into a pot over a fire to be boiled. Whenever this happened no matter how the people heaped on wood, or how long the fire was kept up, the water still remained as cold as when it was taken from the pond; and in the end the little duck was found not in the least harmed, swimming about unconcernedly on the top.\" (the legend of St Colman's ducks)<br /><br />If you're exploring Irish stories you can't avoid a reference to the church. That's the case with the duck, the 8th part of my Feathers of Tales series, where I just couldn't ignore the story of St Colman's ducks.<br /><br />There are many legends around these ducks, all telling about how invincible they were. Some sources even add that they were actually wild ducks, not the domestic ones, so it just fits that I chose this handsome mallard for this picture.<br /><br />Being a common bird (just visit any pond in any park in Dublin) I haven't thought too much about ducks before, but painting the wonderful shiny details on this one I realised, as always, how beautiful these birds are. And because they are used to human presence they make a convenient photo subject as well! The reference photo was taken during lockdown and this boy posed quite happily for me. I also love the earth colours this painting required, it turned out to be a nice heartwarming artwork.<br /><br />Part 8 of the series Feathers of Tales.",
  },
  may: {
    title: 'May',
    imgs: {
      full: {
        src: require('./may_2020_web.jpg'),
        width: 703,
        height: 1000,
      },
      thumb: {
        src: require('./may_2020_thumb.jpg'),
        width: 422,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 210 x 297 mm (8.27 x 11.69 in), 2020.',
    price: 75,
    original: 'SOLD',
    prints: 'SOLD',
    buyUrl: '',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "This robin painting is free to download for my newsletter subscribers! It's an A4 size high quality PDF that you can print for yourself. You can sign up on the <a title=\"PannaDraws home\" href=\"/\">home page</a>!<br /><br />I spotted this little fellow back in May 2020, in the middle of the worst of the lockdown in our local park, when I couldn't really go any further for bird photography. He was totally ignorant of course, singing his heart out as it was the breeding season. Now that it's September I thought it's a nice memory to think back of the blooming trees. For that matter it's nice to think of spring at any time of the year, so I chose this image as a reference for the new printable gift for newsletter subscribers.",
  },
  furcula: {
    title: 'Furcula the First (Feathers of Tales VII)',
    imgs: {
      full: {
        src: require('./furcula_2020_web.jpg'),
        width: 797,
        height: 1000,
      },
      thumb: {
        src: require('./furcula_2020_thumb.jpg'),
        width: 478,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 405 x 508 mm (16 x 20 in), 2020. Framed.',
    price: 250,
    original: 'SOLD',
    prints: 'SOLD',
    printPrice: 26.95,
    buyUrl: 'https://www.etsy.com/ie/listing/864105935/',
    printUrl: 'https://www.etsy.com/ie/listing/889399616/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '"If you get the wishbone on a chicken, catch one end of it and tell somebody else to catch the other end and whoever gets the right side after pulling you may wish for whatever you like." (<a href="http://irisharchaeology.ie/2016/11/animal-sacrifice-and-blood-letting-saint-martins-feast-in-ireland/" target="_blank" rel="noopener noreferrer">Irish superstition</a>)<br/><br/>Chickens might be the most important birds in our lives, yet when it comes to "bird art" I doubt a chicken is what everyone thinks about. Probably most nations in the world have some sort of connection with this animal and hens and roosters are represented in many beliefs and tales. Irish folklore is not an exception, there are many superstitions around chickens, many including the sacrifice of the bird. I just picked one of the less bloody ones as the opening quote, but here\'s another one:<br/><br/>"Some kind of fowl is killed such as chicken or goose and then the blood is sprinkled in the four corners of the kitchen. In some houses there is a cross formed with the blood, or three drops. It is believed if this is done no member of the family will meet with a violent death during the year."<br/><br/>I wanted to show this bird being more than just a wishbone or a sacrifice. If you have different eyes for it, a rooster is a beautiful ornate bird, the king of the yard. He should be portrayed as a king!<br/><br/>This painting is the 7th in my Feathers of Tales series, which features birds of Irish myths and folklore.',
  },
  the_ousel_of_cilgwri: {
    title: 'The Ousel of Cilgwri (Feathers of Tales VI)',
    imgs: {
      full: {
        src: require('./the_ousel_of_cilgwri_2020_web.jpg'),
        width: 711,
        height: 1000,
      },
      thumb: {
        src: require('./the_ousel_of_cilgwri_2020_thumb.jpg'),
        width: 427,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold-pressed watercolour paper. 297 x 420 mm (11.69 x 16.53 in), 2020.',
    price: 115,
    original: 'SOLD',
    prints: 'NOTYET',
    buyUrl: '',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "\"And the Ousel answered, 'When I first came here, there was a smith's anvil in this place, and I was then a young bird; and from that time no work has been done upon it, save the pecking of my beak every evening, and now there is not so much as the size of a nut remaining thereof; yet the vengeance of Heaven be upon me, if during all that time I have ever heard of the man for whom you inquire. Nevertheless I will do that which is right, and that which it is fitting that I should do for an embassy from Arthur. There is a race of animals who were formed before me, and I will be your guide to them.'\" (from the myth <i>Culhwch and Olwen</i>)<br /><br />The blackbird is believed to be one of the oldest animals in the world, along with the stag and the trout, and he's the advisor of many great mythical heroes. I see the blackbird as one of the kindest birds I know, there's a pair nesting in my garden every year. Their second batch of fledglings left the nest early August, but that doesn't mean they don't need their parents attention after. That's why I could get the reference photos of them as both parents were frequent visitors around the feeders at that time.<br /><br />I used two photos in this painting: the posture was provided by the mum, while the texture of the plumage is coming from a picture of the proud dad. This is the 6th piece in my Feathers of Tales series depicting birds in Irish myth and folklore.",
  },
  the_robin: {
    title: 'The Robin (Feathers of Tales V)',
    imgs: {
      full: {
        src: require('./the_robin_2020_web.jpg'),
        width: 708,
        height: 1000,
      },
      thumb: {
        src: require('./the_robin_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold-pressed watercolour paper. 297 x 420 mm (11.69 x 16.53 in), 2020.',
    price: 120,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 21.95,
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/839003450/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '"Well how the boy tried to stay awake! He hadn\'t really slept while lying on the frozen ground and he was still exhausted from the walk. His eyes got lower. His head got lower.  The fire got lower. So low in fact that a starving wolf began to inch near the sleeping pair. However, there was one who was awake. There was one who saw everything from the middle of an old bush; a little bird who was as gray as the brambly wood." (<a href="http://irishhedgerows.weebly.com/folklore.html" target="_blank" rel="noopener noreferrer">Irish folk tale</a>)<br /><br />Although he\'s a common sight, it\'s always a pleasure to meet the little robin. When we moved into our new house he was the first to approach while we were digging up the whole garden. While other birds scatter in a blink of an eye, he stays asking for some snacks. And when he sings, all the other birds seem silent as if they were listening to the melancholic tunes. The robin is truly a kind little companion in my backyard. That\'s why I had to include him in Feathers of Tales.<br /><br />And in case you were wondering how the story ends, how this friendly bird got his distinctive red chest, here you go:<br /><br />"The bird hopped down and began fanning the flickering embers until the flames began to lick out hungrily; nor did the little bird stop, despite the pain on his breast, until the flames were dancing with strength. The heat from the flames changed the colour of his breast feathers and from that day onwards the Robin has proudly worn a red breast." (same folk tale)<br /><br />This is #5 in my Feathers of Tales series, based on birds of Irish folklore. Other pieces are also available in the shop, including the heron, goose, magpie and dove!',
  },
  sparrowhawk: {
    title: 'Sparrowhawk',
    imgs: {
      full: {
        src: require('./sparrowhawk_2020_web.jpg'),
        width: 709,
        height: 1000,
      },
      thumb: {
        src: require('./sparrowhawk_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold-pressed watercolour paper. 297 x 420 mm (11.69 x 16.53 in), 2020.',
    price: 180,
    printPrice: 21.95,
    original: 'SOLD',
    prints: 'AVAILABLE',
    buyUrl: '',
    printUrl: 'https://www.etsy.com/ie/listing/841725878/',
    discount: 0,
    discountPrint: 0,
    merch: [
      {
        name: "Artist's Notebook",
        url: 'https://www.etsy.com/ie/listing/911212429/',
        price: 20.95,
        discount: 0,
        shop: 'notebookShop',
      },
      {
        name: 'Fridge Magnet',
        url: 'https://www.etsy.com/ie/listing/882191122/',
        price: 5.15,
        discount: 0,
        shop: 'stickersShop',
      },
    ],
    type: 'animal_watercolour_painting',
    story:
      "They say the eyes are the windows to the soul. Look at the eyes of this creature, he couldn't even deny his predatory nature! The sparrowhawk, a small bird of prey, but fast, agile and deadly. This one here is a male, which is smaller than the female and has the orange markings. Their skills sparkle most in woodlands, where they cross between the smallest gaps with great speed, and they can chase down prey on foot (?!). Now I'd love to see THAT!<br /><br />I'm always so fond of the variety of birds visiting my garden to feed. And it actually never occurred to me that by attracting so many breeds there's a consequencial visitor as well... I wasn't even aware there are hawks nearby.<br /><br />So I was doing my morning workout and between sets I stared out the kitchen window. Suddenly all the birds took off, and something spiralled down like an arrow. My wandering brain didn't even register what was happening, I remember thinking \"oh, what kind of bird is this, how interesting\" before the shock settled in. \"*@$&! He got a sparrow!! Omg! It's a hawk!\" He sat for 3 seconds in the grass with his prey, then took off. I stood there in complete shock for another minute, thinking I wouldn't have stood a chance. By the time I realised what was happening, that sparrow was dead. That's how I met my sparrowhawk.",
  },
  the_fishermans_son: {
    title: "The Fisherman's Son (Feathers of Tales IV)",
    imgs: {
      full: {
        src: require('./the_fishermans_son_2020_web.jpg'),
        width: 795,
        height: 1000,
      },
      thumb: {
        src: require('./the_fishermans_son_2020_thumb.jpg'),
        width: 477,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on acrylic paper. 405 x 508 mm (16 x 20 in), 2020.',
    price: 180,
    original: 'AVAILABLE',
    prints: 'SOLD',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/827929980/',
    printUrl: 'https://www.etsy.com/ie/listing/841722676/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '"Well" said the Gruagach "you won\'t see your son to-day. At noon-to-morrow I\'ll put a whistle in my mouth and call together all the birds in my place, and they\'ll come. Among others will be twelve doves. I\'ll put my hand in my pocket, this way, and take out wheat and throw it before them on the ground. The doves will eat the wheat, and you must pick your son out of the twelve. If you find him, you\'ll have him; if you don\'t, you\'ll never have him again." (From "Myths and Folk Tales of Ireland" by Jeremiah Curtin)<br /><br />It wasn\'t easy to pick one tale where the white dove plays a major role, but I chose "The Fisherman\'s Son and The Gruagach of Tricks" because it had these typical folk tale elements in it that everyone knows: a fisherman, a boy, a "man of high degree" as a villain, and magic, and the dove.<br /><br />In the painting I wanted to create that gloomy atmosphere that folk tales have, when you know in the end everyone will live happily ever after, but the story is scary, and the fate of the heroes is to suffer and go through trials. I might not tell you a big spoiler when I say the fisherman will save his boy, but the route to that moment is full of darkness and hardships.<br /><br />This is #4 in my Feathers of Tales series, based on birds of Irish folklore. Fun fact: the model I used is a common grey pigeon you see in every city, but I "bleached" her while painting.',
  },
  one_for_sorrow: {
    title: 'One for Sorrow (Feathers of Tales III)',
    imgs: {
      full: {
        src: require('./one_for_sorrow_2020_web.jpg'),
        width: 796,
        height: 1000,
      },
      thumb: {
        src: require('./one_for_sorrow_2020_thumb.jpg'),
        width: 478,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on acrylic paper. 405 x 508 mm (20 x 16 in), 2020.',
    price: 206,
    original: 'MSG',
    prints: 'AVAILABLE',
    printPrice: 24.95,
    buyUrl: 'https://www.etsy.com/ie/listing/834290581/',
    printUrl: 'https://www.etsy.com/ie/listing/841718518/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '"One for sorrow,<br />Two for joy,<br />Three for a girl,<br />Four for a boy,<br />Five for silver,<br />Six for gold,<br />Seven for a secret,<br />Never to be told.<br />Eight for a wish,<br />Nine for a kiss,<br />Ten for a bird,<br />You must not miss<br />Eleven is worse<br />Twelve for a dastardly curse."<br /><br />The mischievous magpie. You can hear his unmistakable chatter everywhere, and you may wonder how many you\'ll come across this time? As this nursery rhyme goes, you might get lucky, but what if there\'s only one? Quickly, ask him how his wife is! Then you might have a chance to avoid misfortune.<br /><br />I chose the magpie for this painting because there\'s scarcely any bird with more superstition around it than this black and white fellow. Although magpies have a pretty negative reputation overall, they are quite intelligent and good looking. You can try get rid of them, but they still figure out a way to get what they want, and then their distinctive chatter sounds like laughter. A common bird in every garden, still a real icon. You might be superstitious or not, but you surely know the magpie.<br /><br />This painting is the 3rd in Feathers of Tales, my series on birds of Irish folklore. Previous artworks in the series are "Old Nog" and "The King\'s Friend", both available in my shop.',
  },
  angelic_hunt: {
    title: 'Angelic Hunt',
    imgs: {
      full: {
        src: require('./angelic_hunt_2020_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./angelic_hunt_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Coloured pencils and pen on paper. 420 x 594 mm (16.53 x 23.39 in), 2020.',
    price: 337,
    original: 'MSG',
    prints: 'NOTYET',
    buyUrl: 'https://www.etsy.com/ie/listing/825365941/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_coloured_pencil_drawing',
    story:
      'Little egrets are fascinating. An angelic appearance with the snow white plumage that gently moves in the wind like some kind of jewellery on the bird. Little egrets are never in a hurry, they move with the elegance of a lady. But when you blink, in that second they catch and kill. They are brilliant predators in the skin of an angel.<br /><br />I met the egret serving as my reference for this drawing during one of my walks. She was busy with her catch so I could capture her in a pose that shows the wild in this beautiful bird. The morning breeze on the seashore was lifting the lighter feathers on her body as she turned towards me, holding her fresh kill. That fish reminded me the egret might look like an angel, but she\'s a deadly one.<br /><br />This drawing was created to enter the art competition "Drawn to Nature" hosted by the <a href="https://ukcps.org.uk" title="UK Coloured Pencil Society" target="_blank" rel="noopener noreferrer" >UK Coloured Pencil Society</a>. The objective of the contest was to capture the wildness of nature, which I found in this hunting egret.',
  },
  the_kings_friend: {
    title: "The King's Friend (Feathers of Tales II)",
    imgs: {
      full: {
        src: require('./the_kings_friend_2020_web.jpg'),
        width: 709,
        height: 1000,
      },
      thumb: {
        src: require('./the_kings_friend_2020_thumb.jpg'),
        width: 425,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 420 x 594 mm (16.53 x 23.39 in), 2020.',
    price: 337,
    original: 'MSG',
    prints: 'AVAILABLE',
    buyUrl: 'https://www.etsy.com/ie/listing/803980602/',
    printUrl: 'https://www.etsy.com/ie/listing/804085940/',
    printPrice: 24.5,
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "\"You see, the goose used to swim across the lake, and go diving for trout, and catch fish on a Friday for the king, and flew every other day round about the lake, diverting the poor king.\" from the story <i>King O'Toole and His Goose</i>.<br /><br />How much time I spent hunting down these timid birds! I was a bit troubled what breed of goose I should choose for the second artwork in my Feathers of Tales project (an art series featuring birds of Irish folklore). I'd naturally go with one that is resident in Ireland, a true Irish breed. But guess what, most geese are here only for the winter, and they migrate to other places to breed during the summer. So do they count as Irish? And there came the lockdown in the spring, so I had to stick to my closest goose neighbours: the light bellied Brent geese.<br /><br />By the time I finished this painting the last of the Brents left for the summer. But this one will remain here to make me long for the freedom they now have. Geese represent a special kind of freedom and adventure for me thanks to my childhood memories of Nils Holgersson. I wonder if we get back to normal by that time this goose comes back for the winter. Until then here's the painting!",
  },
  old_nog: {
    title: 'Old Nog (Feathers of Tales I)',
    imgs: {
      full: {
        src: require('./old_nog_2020_web.jpg'),
        width: 702,
        height: 1000,
      },
      thumb: {
        src: require('./old_nog_2020_thumb.jpg'),
        width: 421,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on watercolour paper. 420 x 594 mm (16.53 x 23.39 in), 2020.',
    price: 405,
    original: 'SOLD',
    prints: 'AVAILABLE',
    printPrice: 28.5,
    buyUrl: 'https://www.etsy.com/ie/listing/795163346/',
    printUrl: 'https://www.etsy.com/ie/listing/803200144/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      '"And so it was that Old Nog, the wisest heron of the Two Rivers, heard the noise of bubbles breaking on the water as he alighted by the pool side" <i>(from Tarka the Otter by Henry Williamson)</i>.<br /><br />During the lockdown I was restricted to the 2km area of my home, so every Saturday early morning I went for a walk to the nearby seashore at Clontarf to photograph the Brent geese that were still lingering around. I was just about to leave with my legs sore from all the squatting with the camera, when something stirred the Brents, who scattered immediately. And then a big shadow descended: the grey heron arrived. I quickly ducked behind the bushes and grabbed my camera again, just in time to take the photo that served as a reference for this painting.<br /><br />This is the opening artwork for my art series "Feathers of Tales". I chose the heron as the kick-off for this major work because how could you be more majestic than this boss?! With his every slow and measured movement he demands the respect. You see him and you helplessly stop and stare. Elegant and deadly, and a real icon of the Irish waterscapes.',
  },
  deer_in_phoenix_park: {
    title: 'Deer in Phoenix Park',
    imgs: {
      full: {
        src: require('./deer_in_phoenix_park_2020_web.jpg'),
        width: 719,
        height: 1000,
      },
      thumb: {
        src: require('./deer_in_phoenix_park_2020_thumb.jpg'),
        width: 431,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on mixed media paper. 297 x 420 mm (11.69 x 16.53 in), 2020.',
    price: 94,
    original: 'SOLD',
    prints: 'SOLD',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/813712057/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      'I created this quick study of a stag to practice the deer head for "The Summoning". I ended up liking the linework so much I decided to finish it as a standalone painting.<br /><br />Here in Dublin one of the city attractions is Phoenix Park, an enormous green patch in the city with forests and fields. These deer roam freely, and some of them are pretty friendly towards people (especially if you have some munchies!). They are quite small though, about the size of a pony. Still when you look at them that same grace shines from their posture that you can see with their bigger cousins.',
  },
  peacock_girls: {
    title: 'Peacock Girls',
    imgs: {
      full: {
        src: require('./peacock_girls_2020_web.jpg'),
        width: 702,
        height: 1000,
      },
      thumb: {
        src: require('./peacock_girls_2020_thumb.jpg'),
        width: 421,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Ink and coloured pencil on cartridge paper. 420 x 594 mm (16.53 x 23.39 in), 2020.',
    price: 337,
    original: 'MSG',
    prints: 'SOLD',
    printPrice: 28.5,
    buyUrl: 'https://www.etsy.com/ie/listing/813749085/',
    printUrl: 'https://www.etsy.com/ie/listing/805000568/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_coloured_pencil_drawing',
    story:
      'Two peahens I captured on camera at Dublin Zoo. The composition is made from two separate photos.<br /><br />The title is wrong on purpose: as a speaker of English as a second language, in my head I tend to simplify English terms and expressions. I always thought of these birds as "girl peacocks" in Hungarian, so I just went with a literal translation when naming this artwork.<br /><br />And why the girls? When you think of this breed, you think of the male. Peacocks are spectacular, colourful, and eye catching. At first sight a peahen doesn\'t look so fascinating, only when you start looking at her closely will you spot the beautiful greenish shine on her plumage and the small orange details on the wings. The peahen\'s look is like a good make up: barely noticeable, but makes all the difference. A worthy pair to the beauty of the peacock.',
  },
  two_geese: {
    title: 'Two Geese',
    imgs: {
      full: {
        src: require('./two_geese_2020_web.jpg'),
        width: 707,
        height: 1000,
      },
      thumb: {
        src: require('./two_geese_2020_thumb.jpg'),
        width: 424,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Coloured pencil on cartridge paper. 420 x 594 mm (16.53 x 23.39 in), 2020.',
    price: 337,
    original: 'MSG',
    prints: 'SOLD',
    buyUrl: 'https://www.etsy.com/ie/listing/795396470/',
    printUrl: 'https://www.etsy.com/ie/listing/819493137/',
    discount: 0,
    discountPrint: 0,
    type: 'animal_coloured_pencil_drawing',
    story:
      "This was my first attempt at coloured pencils, hence my strong linework is missing here, as I was only exploring this medium.<br /><br />While I was working on this drawing I realised I love geese. But why, I wondered. I don't know if any readers are familiar with the cartoon <i>Nils Holgersson</i>. When I was a kid I was hooked on the concept of someone going on an adventure on the back of a goose! How cool is that? I believe my thing for geese comes from this childhood experience.",
  },
  hen_and_rooster: {
    title: 'Hen and Rooster',
    imgs: {
      full: {
        src: require('./hen_and_rooster_2020_web.jpg'),
        width: 1000,
        height: 709,
      },
      thumb: {
        src: require('./hen_and_rooster_2020_thumb.jpg'),
        width: 600,
        height: 425,
      },
    },
    year: '2020',
    description:
      'Ink and watercolour on cold pressed watercolour paper. 297 x 420 mm (16.53 x 11.69 in), 2020.',
    price: 175,
    original: 'MSG',
    prints: 'AVAILABLE',
    buyUrl: 'https://www.etsy.com/ie/listing/813717687/',
    printUrl: 'https://www.etsy.com/ie/listing/804170108/',
    printPrice: 21.95,
    discount: 0,
    discountPrint: 0,
    type: 'animal_watercolour_painting',
    story:
      "The source of this painting is two photos I took at the Lisbon Zoo. I wanted to create a vintage feeling with this one, something that really reminds me of country lifestyle.<br /><br />I deliberately put the hen in front, even though roosters tend to be more colourful and decorative. Maybe there was some feminist idea lurking at the back of my head... I only realised later this painting reminds me of <i>American Gothic</i> by Grant Wood. But there the woman is in the background, which I don't like! Let's give some spotlight to the ladies.",
  },
  rooster_II: {
    title: 'Rooster II',
    imgs: {
      full: {
        src: require('./rooster_II_2020_web.jpg'),
        width: 721,
        height: 1000,
      },
      thumb: {
        src: require('./rooster_II_2020_thumb.jpg'),
        width: 433,
        height: 600,
      },
    },
    year: '2020',
    description:
      'Coloured pencil on paper. 210 x 297 mm ( 8.27 x 11.69 in), 2020.',
    price: 62,
    original: 'AVAILABLE',
    prints: 'SOLD',
    ship: 'FREE_IRL',
    buyUrl: 'https://www.etsy.com/ie/listing/799953144/',
    printUrl: '',
    discount: 0,
    discountPrint: 0,
    type: 'animal_coloured_pencil_drawing',
    story:
      "Another quick practice with coloured pencils. I took the reference photo at a local farm. Whenever I visit such a place I'm always reminded how much I enjoy these simple animals. You can get me tigers, horses and all kind of majestic beasts, my all time favourites are farm birds!",
  },
};

export default imgData_2020;
